import { InfoWindow } from '@vis.gl/react-google-maps';
import PropTypes from 'prop-types';
import { BsGeoAlt, BsGlobe, BsTelephone, BsStar } from 'react-icons/bs';

export default function PlaceInfoWindow({ place, onClose }) {
	if (!place) return null;

	const { name, address, position, website, nationalPhoneNumber, rating, userRatingsTotal } = place;

	return (
		<InfoWindow
			position={position}
			onCloseClick={onClose}
			headerContent={<div className="font-semibold text-lg text-text px-4 pt-3">{name}</div>}
		>
			<div className="p-4 max-w-sm">
				{/* Address */}
				{address && (
					<div className="flex items-start gap-2 mb-3">
						<BsGeoAlt className="w-4 h-4 text-bgBase-800 mt-0.5 flex-shrink-0" />
						<span className="text-sm text-text">{address}</span>
					</div>
				)}

				{/* Phone */}
				{nationalPhoneNumber && (
					<div className="flex items-center gap-2 mb-3">
						<BsTelephone className="w-4 h-4 text-bgBase-800 flex-shrink-0" />
						<a
							href={`tel:${nationalPhoneNumber}`}
							className="text-sm text-primary-600 hover:text-primary-700 hover:underline"
						>
							{nationalPhoneNumber}
						</a>
					</div>
				)}

				{/* Website */}
				{website && (
					<div className="flex items-center gap-2 mb-3">
						<BsGlobe className="w-4 h-4 text-bgBase-800 flex-shrink-0" />
						<a
							href={website}
							target="_blank"
							rel="noopener noreferrer"
							className="text-sm text-primary-600 hover:text-primary-700 hover:underline truncate"
						>
							{new URL(website).hostname}
						</a>
					</div>
				)}

				{/* Rating */}
				{rating && (
					<div className="flex items-center gap-2 mb-3">
						<BsStar className="w-4 h-4 text-caution-500 flex-shrink-0" />
						<span className="text-sm text-text">
							{rating.toFixed(1)} / 5.0
							{userRatingsTotal && (
								<span className="text-bgBase-800 ml-1">({userRatingsTotal} Bewertungen)</span>
							)}
						</span>
					</div>
				)}
			</div>
		</InfoWindow>
	);
}

PlaceInfoWindow.propTypes = {
	place: PropTypes.shape({
		placeId: PropTypes.string,
		place_id: PropTypes.string,
		name: PropTypes.string,
		address: PropTypes.string,
		position: PropTypes.shape({
			lat: PropTypes.number,
			lng: PropTypes.number,
		}),
		website: PropTypes.string,
		nationalPhoneNumber: PropTypes.string,
		rating: PropTypes.number,
		userRatingsTotal: PropTypes.number,
	}),
	onClose: PropTypes.func.isRequired,
};
